// extracted by mini-css-extract-plugin
export default {"errorMessage":"file-uploader-error-message_errorMessage__jdlbw","errorIcon":"file-uploader-error-message_errorIcon__IAte0"};